import { Input } from "@/shared/components/shadcn/Input";
import { FormField } from "@/shared/components/ui/FormField";

interface ProfileFieldsProps {
  value: { firstName: string; lastName: string };
  onChange: (value: ProfileFieldsProps["value"]) => void;
  email?: string;
}

export function ProfileFields({ value, onChange, email }: ProfileFieldsProps) {
  return (
    <>
      <FormField id="first-name" label="First name">
        <Input required pattern=".*\S.*" title="Enter your first name, not just spaces." autoComplete="given-name" value={value.firstName} onChange={(event) => onChange({ ...value, firstName: event.target.value })} />
      </FormField>
      <FormField id="last-name" label="Last name">
        <Input required pattern=".*\S.*" title="Enter your last name, not just spaces." autoComplete="family-name" value={value.lastName} onChange={(event) => onChange({ ...value, lastName: event.target.value })} />
      </FormField>
      {email && (
        <FormField id="account-email" label="Account email" description="The email you use to sign in.">
          <Input type="email" autoComplete="email" readOnly value={email} />
        </FormField>
      )}
    </>
  );
}
